export default "__VITE_ASSET__BaVKQ0HY__"